/**
 * Minimal toast surface for user-visible playback / network errors.
 *
 * TEM-870 — wires <audio> error events into a visible UI signal. The
 * spec called for @tempest/ui's Toast, but radio frontend is CRA-based
 * (not Vite) and doesn't currently consume @tempest/ui; this inline
 * fallback keeps the dependency surface unchanged.
 */
import React from 'react';
import './ErrorToast.css';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ErrorToastProps {
  message: string;
  action?: ToastAction;
  onDismiss: () => void;
}

export const ErrorToast: React.FC<ErrorToastProps> = ({ message, action, onDismiss }) => {
  return (
    <div
      className="error-toast"
      role="alert"
      aria-live="assertive"
      data-testid="error-toast"
    >
      <span className="error-toast__message">{message}</span>
      <div className="error-toast__actions">
        {action && (
          <button
            type="button"
            className="error-toast__retry"
            onClick={action.onClick}
            data-testid="error-toast-retry"
          >
            {action.label}
          </button>
        )}
        <button
          type="button"
          className="error-toast__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
};
